import { useEffect, useState } from "react"

import React from "react"
import { Cookies } from "react-cookie"
import Container from "../InsureInformation1/BodyCarInformation/InsurBodyCar_css"
import Grid from "@material-ui/core/Grid"
import FloatingLabelInput from "../FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import AddIcon from "@material-ui/icons/Add"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableHead from "@material-ui/core/TableHead"
import TableRow from "@material-ui/core/TableRow"
import TableCell from "@material-ui/core/TableCell"
import TableBody from "@material-ui/core/TableBody"
import Moment from "moment"
import JDate from "jalali-date"
import TableContainer from "@material-ui/core/TableContainer"
import Typography from "@material-ui/core/Typography"
import ImageUploader from "react-images-upload"
import LinearProgress from "@material-ui/core/LinearProgress"
import Avatar from "@material-ui/core/Avatar"
import { Lightbox } from "react-modal-image"
import * as constants from "../../constants"

export default function EngineeringSystemComments({ request_id, agent_id, getRequest }) {
    const [data, setData] = useState([])
    const [requestcouncil_desc, setrRequestcouncil_desc] = useState("")
    const [percent, setPercent] = useState(0)
    const [picturesRequestReady, setrPicturesRequestReady] = useState("")
    const [openImageBox, setOpenImageBox] = useState(false)
    const [image, setImage] = useState(false)
    const [timage, setTImage] = useState(false)
    const cookies = new Cookies()

    useEffect(() => {
        getRequestCouncil()
    }, [request_id])

    async function getRequestCouncil() {
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                console.log(this.responseText)
                if (arr.result === "ok") {
                    console.log(arr.data)
                    setData(arr.data)
                }
            }
        }
        var fd = new FormData()
        fd.append("command", "get_comments")
        fd.append("request_id", request_id)

        xhttp.open("POST", `${constants.BASE_URL}/EngineeringSystem`)
        xhttp.setRequestHeader("Authorization", cookies.get("employee_token_str"))
        xhttp.send(fd)
    }

    async function uploadPicDelivery() {
        setPercent(0)
        if (picturesRequestReady && picturesRequestReady !== "" && picturesRequestReady !== null) {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)
                    console.log(arr)
                    if (arr.result === "ok") {
                        setPercent(0)

                        addRequestCouncil(arr.data["image_code"])
                    } else if (arr.result === "error") {
                    }
                }
            }
            var fd = new FormData()
            fd.append("command", "uploadpic")
            fd.append("image", picturesRequestReady)
            fd.append("image_name", " تصویر کامنت های")
            fd.append("image_desc", " تصویر اضافه شده به کامنت های کارمندان صدور")
            fd.append("name", "")
            xhttp.upload.addEventListener(
                "progress",
                function(evt) {
                    if (evt.lengthComputable) {
                        var percentComplete = evt.loaded / evt.total
                        setPercent(percentComplete * 100)
                    }
                },
                false
            )
            xhttp.open("POST", `${constants.BASE_URL}/image`)
            xhttp.send(fd)
        } else {
            addRequestCouncil("")
        }

    }

    async function addRequestCouncil(image_code) {
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                console.log(this.responseText)
                if (arr.result === "ok") {
                    getRequestCouncil(arr)
                }
            }
        }
        var fd = new FormData()
        fd.append("command", "add_comments")
        fd.append("request_id", request_id)
        fd.append("comment_sms_receiver_text", requestcouncil_desc)
        fd.append("comment_sms_receiver_image_code", image_code)
        xhttp.open("POST", `${constants.BASE_URL}/EngineeringSystem`)
        xhttp.setRequestHeader("Authorization", cookies.get("employee_token_str"))
        xhttp.send(fd)
        setrRequestcouncil_desc("");

    }

    return (
        <Container>
            <div className="root">
                <Grid item xs={12}>
                    <Grid container spacing={3}>
                        <Grid item item xs={12}>
                            <div style={{ width: "100%", textAlign: "right" }}>
                                <Typography align="center" variant="h7">
                                    {"شماره درخواست: " + request_id}
                                </Typography>
                                {console.log('request_id',request_id)}
                            </div>
                        </Grid>
                        <Grid item item xs={12}>
                            <TableContainer component={Paper}>
                                <Table aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{ minWidth: 30 }} align="center">
                                                تاریخ
                                            </TableCell>
                                            <TableCell style={{ minWidth: 30 }} align="center">
                                                تصویر
                                            </TableCell>
                                            <TableCell style={{ minWidth: 100 }} align="center">
                                                توضیحات{" "}
                                            </TableCell>
                                            <TableCell style={{ minWidth: 30 }} align="center">
                                                کارمند
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data.map((row) => {
                                            var varmoment = Moment(row.comment_time, "YYYY-M-D HH:mm:ss")
                                            var date = new Date(parseInt(varmoment.format("x")))
                                            var jdate1 = new JDate(date)
                                            var dateMinStr = jdate1.format("YYYY/MM/DD") + "ساعت " + varmoment.format("HH:mm")

                                            return (
                                                <TableRow key={row.requestcouncil_id}>
                                                    <TableCell align="center">{dateMinStr}</TableCell>
                                                    <TableCell align="center">
                                                        <div style={{ width: "100%", textAlign: "center" }}>
                                                            <Avatar
                                                                variant="rounded"
                                                                alt="Remy Sharp"
                                                                src={row.requestcouncil_timage}
                                                                onClick={() => {
                                                                    setOpenImageBox(true)
                                                                    setImage(row.requestcouncil_image)
                                                                    setTImage(row.requestcouncil_timage)
                                                                }}
                                                            />
                                                        </div>
                                                    </TableCell>
                                                    <TableCell align="center">{row.comment_text}</TableCell>
                                                    <TableCell align="center">
                                                        {row.employee_name
                                                            ? row.employee_name + " " + row.employee_family
                                                            : ""}
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>

                        <Grid item item xs={8}>
                            <FloatingLabelInput
                                placeholder="توضیحات"
                                handleInputt={(e) => {
                                    setrRequestcouncil_desc(e.target.value)
                                }}
                                value={requestcouncil_desc}
                            />
                        </Grid>
                        <Grid item item xs={2}>
                            <ImageUploader
                                withIcon={true}
                                buttonText="عکس را انتخاب نمایید"
                                onChange={(picture) => {
                                    setrPicturesRequestReady(picture[0])
                                }}
                                withPreview="true"
                                singleImage="true"
                                imgExtension={[".jpg", ".jpeg", ".gif", ".png", ".gif", ".svg", ".tiff", ".webp", ".Lottie"]}
                                maxFileSize={5242880}
                            />
                        </Grid>
                        <Grid item item xs={2}>
                            <div style={{ width: "100%", textAlign: "left" }}>
                                <Fab
                                    color="primary"
                                    aria-label="add"
                                    onClick={(e) => {
                                        uploadPicDelivery()
                                    }}
                                >
                                    <AddIcon />
                                </Fab>
                            </div>
                        </Grid>
                        {percent > 0 ? (
                            <Grid item item xs={12}>
                                <LinearProgress variant="determinate" value={percent} />
                            </Grid>
                        ) : null}
                    </Grid>
                </Grid>
            </div>
            {openImageBox && (
                <Lightbox
                    medium={timage}
                    large={image}
                    alt={"توضیحات"}
                    onClose={() => {
                        setOpenImageBox(false)
                    }}
                    showRotate={true}
                    hideZoom={false}
                />
            )}
        </Container>
    )
}
